var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 19.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".dots_svg__cls-2{fill:#333}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dots_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dots_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M0 18h75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dots_svg__cls-2",
    d: "M0 0h6.37v7.09H0zM10.02 0h6.37v7.09h-6.37zM20.03 0h6.37v7.09h-6.37zM30.05 0h6.37v7.09h-6.37zM40.07 0h6.37v7.09h-6.37z"
  })))));
}
export default SvgDots;